export const GENOGRAM_EXPORT_FONT_STACK_LATIN =
  "Inter, 'Noto Sans', 'Noto Sans Arabic', system-ui, -apple-system, sans-serif";

export const GENOGRAM_EXPORT_FONT_STACK_ARABIC =
  "'Noto Sans Arabic', Inter, 'Noto Sans', system-ui, -apple-system, sans-serif";

const ARABIC_SCRIPT_PATTERN = /\p{Script=Arabic}/u;

export function resolveGenogramExportFontStack(
  text: string,
  preferredFamily?: string | null,
): string {
  const preferred = typeof preferredFamily === 'string' ? preferredFamily.trim() : '';
  if (preferred.length > 0) {
    return `${preferred}, Inter, 'Noto Sans', 'Noto Sans Arabic', system-ui, -apple-system, sans-serif`;
  }
  if (ARABIC_SCRIPT_PATTERN.test(text)) {
    return GENOGRAM_EXPORT_FONT_STACK_ARABIC;
  }
  return GENOGRAM_EXPORT_FONT_STACK_LATIN;
}
